import LoadingSpinner from './LoadingSpinner';

export default function InsetLoadingOverlay({ message }) {
  return (
    <div className="absolute inset-0 cursor-default flex justify-center items-center z-50">
      <div className="absolute opacity-50 h-full w-full inset-0 bg-gray-500"></div>
      <div className="absolute h-full w-full inset-0 flex justify-center">
        <div className="mx-auto my-auto py-24 px-16 w-1/2 xl:w-2/6 h-80 flex flex-col justify-center bg-white rounded-half shadow-lg">
          <LoadingSpinner message={message} />
        </div>
      </div>
    </div>
  );
}
